export const isValidGoriSignatureHash = (hash: string): boolean => {
  return /^[a-zA-Z0-9]{15}$/.test(hash)
}
